export const EVENT_TYPES = {
  SHOP_VIEW: {
    key: 1,
    label: 'Shop View',
  },
  CHAT: {
    key: 2,
    label: 'Chat',
  },
  PRODUCT_VIEW: {
    key: 3,
    label: 'Product View',
  },
  CALL: {
    key: 4,
    label: 'Call',
  },
}
